import { render, staticRenderFns } from "./upload-status-select.vue?vue&type=template&id=704d7adb"
import script from "./upload-status-select.vue?vue&type=script&lang=js"
export * from "./upload-status-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports